import Bowser from 'bowser';

type UserAgentInfo = { browser?: string; os?: string };

/**
 * Extracts a compact browser (name + major version, e.g. "Chrome 150") and OS
 * family (e.g. "macOS") from a user agent string. This keeps the metric payload
 * small versus the full UA and is more useful for slicing — on Outlook desktop
 * the raw UA just reflects the embedded webview. Returns {} for a missing UA.
 */
export const parseUserAgent = (userAgent?: string): UserAgentInfo => {
  if (!userAgent) {
    return {};
  }

  const parser = Bowser.getParser(userAgent);
  const name = parser.getBrowserName();
  const majorVersion = parser.getBrowserVersion()?.split('.')[0];

  return {
    browser: name ? `${name} ${majorVersion ?? ''}`.trim() : undefined,
    os: parser.getOSName() || undefined,
  };
};
